import React from "react";
import useApprovedDetails from "./useApprovedDetails";
import {
  ModalLayout,
  Pagination,
  SearchFilters,
  // Table,
} from "@wac-ui-dashboard/wac_component_library";
import { FaSort } from "react-icons/fa";
import EditApprovedCertificate from "./EditApprovedCertificate";
import Style from "../../verifications.module.scss";
import ExcelUpload from "./ExcelUpload";
import CancelVerificationModal from "./CancelVerificationModal";
import BarcodeWorkModal from "./BarcodeWorkModal";
import Select from "react-select";
import { Table } from "../../../Global/Table";

const ApprovedDetails = ({
  gliNumber,
  barCodeRef,
  officeSlipRef,
  StockReceiptRef,
  selectionRef,
  selectionRef2,
  allCertificates,
  setAllCertificates,
}) => {
  const {
    basicData,
    isFetching,
    tableFields,
    approvedState,
    paginationOptions,
    ApprovedDetailsList,
    handleStockReceiptPrint,
    handleOfficeSlipPrint,
    handlePrintBarCode,
    refetch,
    getRow,
    handleSearch,
    handlePageSize,
    handleClearClick,
    handlePagination,
    handleApprovedData,
    handleExcelFileUpload,
    handleExcelFileDownload,
    handleCloseCancelModal,
    handleOpenCancelModal,
    dispatch,
    updateConfig,
    CertficateNumberOptions,
    handlerangeSubmit,
    handleCertifcateFrom,
    handleCertificateTo,
    filteredFromOptions,
    filteredToOptions,
    detailrefetch,
    handleAddRange,
    handleRemoveRange,
    getCertificateLabel,
    handleBarcodeWork,
  } = useApprovedDetails({
    barCodeRef,
    officeSlipRef,
    StockReceiptRef,
    selectionRef,
    selectionRef2,
    allCertificates,
    setAllCertificates,
  });
  return (
    <div className="pro-w-100">
      <div className={`pro-mb-5 ${Style.head}`}>
        <h5 className="pro-ttl h5 pro-mb-2">{gliNumber}</h5>
        <div className={Style.btns}>
          <button
            className={`${Style.Print_btn} ${Style.barcode_btn} pro-btn pro-items-center 
            ${approvedState.barcodeWorkCompleted ? "outline-success" : "pro-btn-outline"}`}
            onClick={handleBarcodeWork}
            disabled={approvedState.barcodeWorkCompleted}
          >
            <span className="material-symbols-outlined">
              {approvedState.barcodeWorkCompleted ? "check" : "assignment"}
            </span>
            <span>Barcode Work</span>
          </button>
          <button
            className={`${Style.Print_btn} pro-btn pro-items-center pro-btn-outline`}
            onClick={handleExcelFileDownload}
          >
            <span className="material-symbols-outlined">download</span>
            <span>Excel Download</span>
          </button>
          <button
            className={`${Style.Print_btn} pro-btn pro-items-center pro-btn-outline`}
            onClick={handleExcelFileUpload}
          >
            <span className="material-symbols-outlined">upload</span>
            <span>Excel Upload</span>
          </button>
          <button
            className={`${Style.Print_btn} pro-btn pro-items-center pro-btn-outline`}
            onClick={handleStockReceiptPrint}
          >
            <span className="material-symbols-outlined">list_alt</span>
            <span>Print Stock Receipt</span>
          </button>
          <button
            className={`${Style.Print_btn} pro-btn pro-items-center pro-btn-outline`}
            onClick={handleOfficeSlipPrint}
          >
            <span className="material-symbols-outlined">apartment</span>
            <span>Print Office Slip</span>
          </button>
          <button
            className={`${Style.Print_btn} pro-btn pro-items-center pro-btn-outline`}
            onClick={handlePrintBarCode}
          >
            <span className="material-symbols-outlined">barcode_scanner</span>
            <span>Print Barcode</span>
          </button>
        </div>
      </div>

      <SearchFilters
        onSearchInput={handleSearch}
        showActions={false}
        SearchIcon={<span className="material-symbols-outlined"> search </span>}
        showClearFilters
        handleClear={handleClearClick}
        searchInputProps={{ value: approvedState?.search, placeholder: "Search Certificate Number" }}
      />
      <div className="pro-pt-3">
        <div className="row g-4">
          <div className="col-4">
            <label className="pro-font-sm pro-mb-1 pro-fw-medium">
              Range 1
            </label>
            <Select
              placeholder="Select"
              classNamePrefix={"pro-input"}
              className="pro-input lg"
              ref={selectionRef}
              options={filteredFromOptions}
              isSearchable
              menuPortalTarget={document.body}
              onChange={handleCertifcateFrom}
              menuPosition="fixed"
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              }}
            />
          </div>

          <div className="col-4">
            <label className="pro-font-sm pro-mb-1 pro-fw-medium">
              Range 2
            </label>
            <Select
              placeholder="Select"
              ref={selectionRef2}
              classNamePrefix={"pro-input"}
              className="pro-input lg"
              options={filteredToOptions}
              isSearchable
              menuPortalTarget={document.body}
              onChange={handleCertificateTo}
              menuPosition="fixed"
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              }}
            />
          </div>

          <div className="col-auto pro-align-self-end">
            <button
              className="pro-btn pro-btn-secondary  me-2"
              onClick={handleAddRange}
              disabled={
                !(
                  approvedState?.certificate_number_from &&
                  approvedState?.certificate_number_to
                )
              }
            >
              Add +
            </button>
          </div>

          <div className="col-auto pro-align-self-end">
            <button
              className="pro-btn pro-btn-primary"
              onClick={handlerangeSubmit}
              disabled={!approvedState?.certificate_number_ranges?.length}
            >
              Submit
            </button>
          </div>
        </div>

        {approvedState?.certificate_number_ranges?.length > 0 && (
          <div className="pro-mt-3 pro-d-flex pro-flex-wrap pro-align-items-center pro-gap-2 ">
            {approvedState.certificate_number_ranges.map((range, index) => (
              <div
                key={index}
                className="pro-d-flex pro-align-items-center pro-gap-2 pro-mb-2"
              >
                <span className="pro-badge outline-primary">
                  {getCertificateLabel(range[0])} -{" "}
                  {getCertificateLabel(range[1])}
                </span>
                <span
                  className="material-symbols-outlined cursor-pointer text-danger"
                  onClick={() => handleRemoveRange(index)}
                  style={{ cursor: "pointer" }}
                >
                  close
                </span>
              </div>
            ))}
          </div>
        )}
      </div>

      <Table
        multiSelect={true}
        data={ApprovedDetailsList?.data?.data}
        uniqueID={"id"}
        fields={tableFields}
        showCheckBox={true}
        clear={approvedState.clearSelection}
        assignText={"Cancel or Return"}
        // deleteText={"Return"}
        SortIcon={<FaSort />}
        editIcon={<span className="material-symbols-outlined">edit</span>}
        // deleteIcon={<span className="material-symbols-outlined">keyboard_return</span>}
        assignIcon={
          <span className="material-symbols-outlined">keyboard_return</span>
        }
        getRow={getRow}
        loading={isFetching}
        // handleDelete={handleOpenCancelModal}
        handleAssign={handleOpenCancelModal}
        handleEdit={handleApprovedData}
        perpage={10}
        assignable={true}
        deletable={false}
        extraClasssName={`pro-pb-6`}
      />
      <Pagination
        currentPage={approvedState?.currentPage}
        totalPageCount={Math.ceil(
          ApprovedDetailsList?.data?.total_count /
            ApprovedDetailsList?.data?.per_page,
        )}
        onPageChange={handlePagination}
        options={paginationOptions}
        onActionChange={handlePageSize}
        center
      />
      <ModalLayout
        show={approvedState?.showAddOrderModal}
        handleClose={handleApprovedData}
        title={"Edit Verification Data"}
        closeIcon={<span className="material-symbols-outlined"> close </span>}
      >
        <div className="pro-m-5">
          <EditApprovedCertificate
            handleApprovedData={handleApprovedData}
            basicData={basicData}
            refetch={refetch}
          />
        </div>
      </ModalLayout>
      <ModalLayout
        show={approvedState.showExcelUploadModal}
        handleClose={handleExcelFileUpload}
        title={`Excel Upload`}
        closeIcon={<span className="material-symbols-outlined"> close </span>}
      >
        <div className="pro-m-5">
          <ExcelUpload />
        </div>
      </ModalLayout>
      <ModalLayout
        show={approvedState.showCancelmodal}
        handleClose={handleCloseCancelModal}
        title={"Cancel  or Partial Return "}
        centered
        closeIcon={<span className="material-symbols-outlined">close</span>}
        backdrop="static"
      >
        <div className="pro-m-5">
          <CancelVerificationModal
            handleClose={handleCloseCancelModal}
            refetch={refetch}
            approvedState={approvedState}
            selectedItem={approvedState?.selectedItem}
            dispatch={dispatch}
            updateConfig={updateConfig}
            selectionRef={selectionRef}
            selectionRef2={selectionRef2}
            // detailrefetch={detailrefetch}
          />
        </div>
      </ModalLayout>
      <ModalLayout
        show={approvedState.showBarcodeWorkModal}
        handleClose={handleBarcodeWork}
        title={"Submit Barcode Work"}
        centered
        closeIcon={<span className="material-symbols-outlined">close</span>}
        backdrop="static"
      >
        <div className="pro-m-5">
          <BarcodeWorkModal
            handleClose={handleBarcodeWork}
            refetch={refetch}
            approvedState={approvedState}
          />
        </div>
      </ModalLayout>
    </div>
  );
};

export default ApprovedDetails;
